export const onboardingTabsArray = [
  { title: "ALL" },
  {
    title: "ENABLED",
  },
  { title: "DISABLED" },
];
